module.exports = __webpack_public_path__ + "images/graphic-panel-1@2x_0d93604c0ce2a4633a0fe5cfab355433.png";